import React, { useEffect } from 'react';
import { CheckCircle2, Award, ChevronRight } from 'lucide-react';

const SuccessView = ({ result, tenant, menuData, onGoToPortal, t, isGlobal }) => {
    const earnedAmount = result.points || 0;
    const buttonText = isGlobal ? t('portal.myBusinesses', 'İşletmelerim') : (menuData?.name || t('portal.menu', 'Dijital Menü'));
    
    useEffect(() => {
        const timer = setTimeout(() => {
            onGoToPortal();
        }, 2500); // 2.5 seconds for better readability
        return () => clearTimeout(timer);
    }, [onGoToPortal]);
    
    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-main)', padding: '2rem' }}>
            <div className="card glass-premium" style={{ maxWidth: '400px', width: '100%', padding: '3rem', textAlign: 'center' }}>
                <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 2rem',
                    background: 'rgba(34, 197, 94, 0.1)',
                    color: '#22c55e',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CheckCircle2 size={40} />
                </div>
                
                <h1 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '0.75rem' }}>
                    {result.isNew ? (t('checkin.newCustomer', 'Aramıza Katıldınız!')) : (result.name ? `Hoş Geldiniz, ${result.name}!` : 'Tekrar Hoş Geldiniz!')}
                </h1>
                
                <p style={{ color: 'var(--text-muted)', marginBottom: '2.5rem' }}>
                    {earnedAmount > 0 
                        ? (result.isNew ? 'Üyeliğiniz başarıyla oluşturuldu.' : 'Ziyaretiniz başarıyla kaydedildi.') 
                        : (result.isNew ? 'Hesabınız oluşturuldu. Portala hoş geldiniz!' : 'Sizi tekrar görmek çok güzel.')}
                </p>

                <div 
                    className="card" 
                    style={{ 
                        background: earnedAmount > 0 ? 'var(--primary)' : 'rgba(var(--primary-rgb), 0.08)', 
                        color: earnedAmount > 0 ? 'white' : 'var(--primary)', 
                        padding: '1.75rem', 
                        borderRadius: '24px', 
                        marginBottom: '2rem',
                        border: earnedAmount > 0 ? 'none' : '1px solid rgba(var(--primary-rgb), 0.15)'
                    }}
                >
                    <Award size={36} style={{ marginBottom: '0.5rem' }} />
                    <div style={{ fontSize: '1.35rem', fontWeight: 900, marginBottom: '4px' }}>
                        {earnedAmount > 0 ? `+${earnedAmount} Puan Kazandınız!` : 'Giriş Başarılı'}
                    </div>
                </div>

                <button 
                    onClick={onGoToPortal} 
                    className="btn-primary"
                    style={{ 
                        width: '100%', 
                        padding: '1rem',
                        borderRadius: '16px',
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        gap: '8px',
                        fontWeight: 800,
                        fontSize: '1rem',
                        cursor: 'pointer'
                    }}
                >
                    {buttonText} <ChevronRight size={20} />
                </button>
            </div>
        </div>
    );
};

export default SuccessView;
